import { z } from 'zod';
import { CreditResolutionMethod, CrewClaimTypeEnum } from '../../enums/crew.js';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
import { claimAddress } from './address.js';
import { calculatedLineItemApplication, calculatedOrderLineItem, calculatedOrderLineItemResponse, } from './claimLineItem.js';
import { customerUiEventCustomField } from './customField.js';
import { financialSectionItem } from './financialSection.js';
import { Pegasus } from './pegasus.js';
import { rate, returnShipmentMethod } from './shipmentRate.js';
export const calculatedOrder = z.object({
    id: z.number(),
    claimType: enumToZodLiteralUnion(CrewClaimTypeEnum),
    calculatedLineItems: z.array(calculatedOrderLineItem),
    shopNowIncentiveAmountApplied: z.number().optional(),
    returnShipment: returnShipmentMethod.nullish(),
    toCustomerRate: rate.nullish(),
    exchangeMethod: z
        .union([z.literal('instant'), z.literal('standard')])
        .optional(),
    creditResolutionMethod: z.nativeEnum(CreditResolutionMethod).optional(),
});
export const calculatedOrderClaimLineItemReview = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
})
    .extend({
    address: claimAddress.optional(),
    email: z.string().optional(),
});
export const calculatedOrderShipmentQuote = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
})
    .extend({
    email: z.string(),
    address: claimAddress,
    globalEOrderId: z.string().optional(),
});
export const calculatedOrderDraft = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
    calculatedLineItems: true,
})
    .extend({
    calculatedLineItems: z.array(calculatedOrderLineItem.omit({
        requestedResolutionMethodEnum: true,
        id: true,
        originalStoreOrderLineItem: true,
    })),
});
// --------- response bodies -----------------------
export const calculatedAfterReasonSelection = z.object({
    eventPolicyEnforcement: Pegasus.eventPolicyEnforcement.nullable(),
    eventCustomFields: customerUiEventCustomField.nullable(),
    omittedResolutionMethods: Pegasus.omittedResolutionMethodOptions.optional(),
});
export const financialSection = z.object({
    total: z.number(),
    lineItems: z.array(calculatedOrderLineItemResponse),
    sections: z.array(financialSectionItem),
});
export const lineItemFeeApplication = z.object({
    calculatedLineItemId: z.string(),
    storeRuleId: z.number().optional(),
    fee: z.object({
        amount: z.number(),
        displayName: z.string(),
    }),
});
export const calculatedBeforeClaimSubmission = z.object({
    credits: financialSection,
    deductions: financialSection,
    lineItemApplications: z.array(calculatedLineItemApplication),
    lineItemFeeApplications: z.array(lineItemFeeApplication),
    balance: z.number(),
    paymentIntent: z
        .object({
        clientSecret: z.string(),
        amount: z.number(),
        idFromPlatform: z.string(),
    })
        .optional(),
});
//# sourceMappingURL=calculatedOrder.js.map